module.exports = __webpack_public_path__ + "img/yoyow.9196885c.svg";